import { termsAndConditionsUtil } from '../../util/termsAndConditions-util';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { SizeMe as Resizer } from 'react-sizeme';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = './pdf.worker.min.js';

export const PdfViewer = (): React.ReactElement => {
	const [numPages, setNumPages] = useState<number | null>(null);
	const termsAndConditionsFileUrl = termsAndConditionsUtil();

	const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
		setNumPages(numPages);
	};

	const pdfDocument = ({ size }: any): React.ReactElement => (
		<div
			style={{
				height: '500px',
				overflowY: 'scroll',
				overflowX: 'auto',
				padding: '0 8px',
				borderRadius: '4px',
				display: 'flex',
				justifyContent: 'center',
			}}
		>
			<Document
				file={termsAndConditionsFileUrl}
				onLoadSuccess={onDocumentLoadSuccess}
			>
				{Array.from(new Array(numPages), (el, index) => (
					<Page
						key={`page_${index + 1}`}
						pageNumber={index + 1}
					/>
				))}
			</Document>
		</div>
	);

	return <Resizer>{pdfDocument}</Resizer>;
};
